import { setRowGroup } from "../../../redux/reducers/gridLayoutReducer";

/**
 * Function to process the action definition of a row grouping action. It adds `children` to the action definition based on the `groupParams`
 * provided in the action definition.
 * @param {Object} groupByActionDef The action definition of the row grouping action.
 * @param {Function} dispatch The dispatch function from the redux store.
 * @returns {Object} The processed action definition.
 */
export const processGroupByActionDef = (groupByActionDef, t, dispatch) => {
  if (!groupByActionDef.groupParams?.gridName) {
    throw new Error(
      "SFActionBar: The row grouping action definition must have `groupParams.gridName` defined. Current value: " +
        groupByActionDef.groupParams?.gridName
    );
  }
  if (!groupByActionDef.groupParams?.gridLayout) {
    throw new Error(
      "SFActionBar: The row grouping action definition must have `groupParams.gridLayout` defined. Current value: " +
        groupByActionDef.groupParams?.gridLayout
    );
  }

  const { gridName, gridLayout = {} } = groupByActionDef.groupParams;
  const { current, options = [] } = gridLayout.rowGroup || {};

  return {
    ...groupByActionDef,
    // Add children to the action definition only if the gridName and gridLayout are provided in the groupParams
    children: [
      {
        name: "noGrouping",
        label: t("components.datagrid.groupByNothing"),
        onClick: () =>
          dispatch(
            setRowGroup({
              gridName: gridName,
              current: null,
            })
          ),
      },
      ...options.map((option) => ({
        name: option.label,
        label: option.label,
        onClick: () =>
          dispatch(
            setRowGroup({
              gridName: gridName,
              current: option,
            })
          ),
      })),
    ],
    selectedChild: current?.label || t("components.datagrid.groupByNothing"),
  };
};
